const moneyFormatters = new Map();

/** Same monthly rate as commerce checkout (`checkout-vite` / `pay-do-stable`). */
export const INSTALLMENT_INTEREST_RATE = 0.037;
export const MAX_INSTALLMENTS = 12;
export const MIN_INSTALLMENT_MINOR = 500; // R$ 5,00

export function formatMoney(amountMinor, currency = "BRL") {
  const key = `${currency}:pt-BR`;
  if (!moneyFormatters.has(key)) {
    moneyFormatters.set(
      key,
      new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency,
      })
    );
  }
  return moneyFormatters.get(key).format(Number(amountMinor) / 100);
}

/**
 * Highest installment option that matches commerce checkout math.
 * Returns null when only 1x qualifies (no "ou Nx" line).
 */
export function maxInstallmentPreview(amountMinor) {
  const price = Number(amountMinor);
  if (!Number.isFinite(price) || price <= 0) return null;

  let best = null;
  for (let n = 1; n <= MAX_INSTALLMENTS; n += 1) {
    const valueMinor =
      n === 1
        ? price
        : (price *
            (INSTALLMENT_INTEREST_RATE *
              Math.pow(1 + INSTALLMENT_INTEREST_RATE, n))) /
          (Math.pow(1 + INSTALLMENT_INTEREST_RATE, n) - 1);

    if (valueMinor < MIN_INSTALLMENT_MINOR) break;
    best = { count: n, valueMinor: Math.round(valueMinor) };
  }

  return best?.count > 1 ? best : null;
}

export function formatInstallmentLine(amountMinor, currency = "BRL") {
  const preview = maxInstallmentPreview(amountMinor);
  if (!preview) return null;
  return `ou ${preview.count}x de ${formatMoney(preview.valueMinor, currency)}`;
}
